__turbopack_context__.v({
  "container": "NkPB9q_container",
  "hasIconAfter": "NkPB9q_hasIconAfter",
  "hasIconBefore": "NkPB9q_hasIconBefore",
  "iconAfter": "NkPB9q_iconAfter",
  "iconAfterMargin--lg": "NkPB9q_iconAfterMargin--lg",
  "iconAfterMargin--none": "NkPB9q_iconAfterMargin--none",
  "iconAfterMargin--sm": "NkPB9q_iconAfterMargin--sm",
  "iconAfterMargin--xs": "NkPB9q_iconAfterMargin--xs",
  "iconAfterSize--lg": "NkPB9q_iconAfterSize--lg",
  "iconAfterSize--sm": "NkPB9q_iconAfterSize--sm",
  "iconAfterSize--xs": "NkPB9q_iconAfterSize--xs",
  "iconBefore": "NkPB9q_iconBefore",
  "iconBeforeMargin--lg": "NkPB9q_iconBeforeMargin--lg",
  "iconBeforeMargin--none": "NkPB9q_iconBeforeMargin--none",
  "iconBeforeMargin--sm": "NkPB9q_iconBeforeMargin--sm",
  "iconBeforeMargin--xs": "NkPB9q_iconBeforeMargin--xs",
  "iconBeforeSize--lg": "NkPB9q_iconBeforeSize--lg",
  "iconBeforeSize--sm": "NkPB9q_iconBeforeSize--sm",
  "iconBeforeSize--xs": "NkPB9q_iconBeforeSize--xs",
  "inline": "NkPB9q_inline",
  "label": "NkPB9q_label",
  "width--full": "NkPB9q_width--full",
  "width--maxcontent": "NkPB9q_width--maxcontent",
  "wrapNone": "NkPB9q_wrapNone",
});
